import log from '../../lib/salvo-lite/log'
import axios from 'axios'

class GiftCardAddCart {
    constructor (theme, elem) {
        this._elem = elem

        this._elems = {
            'addToCart': elem.querySelector('[data-gift-card-atc]'),
            'radios': elem.querySelectorAll('[data-gift-card-radio]'),
            'qtyChanges': elem.querySelectorAll('[data-gift-card-qty-change]')
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._initEvents()
    }

    _initEvents () {
        this._toggleRadios()
        this._toggleQuantitySelect()

        this._elems.addToCart.addEventListener('click', e => {
            let checkedRadioElem = [...this._elems.radios].filter(radio => {
                if (radio.checked) return radio
            })[0]

            if (checkedRadioElem !== null) this._addToCart(checkedRadioElem)
        })
    }

    _toggleRadios () {
        for (let radio of this._elems.radios) {
            radio.addEventListener('change', e => {
                for (let label of this._elem.querySelectorAll('[data-gift-card-radio-label]')) {
                    label.classList.remove('is-active')
                }

                let parentLabel = radio.closest('[data-gift-card-radio-label]')
                if (radio.checked === true) parentLabel.classList.add('is-active')
            })
        }
    }

    _toggleQuantitySelect () {
        log.debug(this.constructor.name, 'Qty select', this)
        for (const qtyElem of this._elems.qtyChanges) {
            let qtyBtns = qtyElem.querySelectorAll('[data-gift-card-qty-btn]')
            let qtyField = qtyElem.querySelector('[data-gift-card-qty]')
            for (const qtyBtn of qtyBtns) {
                qtyBtn.addEventListener('click', e => {
                    e.preventDefault()
                    let currentQty = parseInt(qtyField.value)
                    let direction = qtyBtn.dataset.giftCardQtyBtn

                    if (direction === 'add') {
                        qtyField.value = parseFloat(currentQty) + 1
                    }
                    if (direction === 'sub') {
                        qtyField.value = parseFloat(currentQty) - 1
                        if (qtyField.value > 0) {
                            // Do nothing
                        } else {
                            qtyField.value = 1
                        }
                    }
                })
            }
        }
    }

    _addToCart (checkedRadioElem) {
        let productID = parseInt(checkedRadioElem.value)
        let parentElem = this._elem.querySelector(`[data-gc-item="${productID}"]`)
        let parentQtyElem = parentElem.querySelector('[data-gift-card-qty]')

        axios.post('/cart/add.js', {
            quantity: parentQtyElem.value || 1,
            id: productID
        }).then(response => {
            console.group('added')
            console.dir(response)
            console.groupEnd()
            document.dispatchEvent(new Event('added-item'))
            // window.location = '/checkout'
            // document.dispatchEvent(new Event('cartAdded'))
        })
            .catch((error) => {
                console.log(error)
            })
    }
}

export default GiftCardAddCart



// WEBPACK FOOTER //
// ./resources/scripts/components/GiftCardAddCart.js